'use client';

import { styled } from '@mui/material/styles';

import { FontConfig } from '@/global/styles/fonts';

const FontStyle = styled('style')``;

export const CustomFont = ({ fonts }: { fonts: FontConfig[] }) => {
  const uniqueFonts = fonts.filter(
    (font, index, self) => font.url && index === self.findIndex(f => f.url === font.url),
  );

  return (
    <>
      {uniqueFonts.map((font, index) => {
        if (!font.url) return null;

        if (font.url.includes('fonts.googleapis.com')) {
          return <link key={index} rel='stylesheet' href={font.url} />;
        }

        const fontFaceStyles = `
          @font-face {
            font-family: "${font.family}";
            src: url("${font.url}") format("woff2");
            font-display: swap;
          }
        `;

        return <FontStyle key={index} dangerouslySetInnerHTML={{ __html: fontFaceStyles }} />;
      })}
    </>
  );
};
